import React from 'react';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { Instagram, Shield, Zap, HeadphonesIcon } from 'lucide-react';

export const Hero = () => {
  const scrollToOffers = () => {
    const element = document.getElementById('offers');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center pt-32 pb-20 px-4 overflow-hidden">
      {/* Animated Background Elements */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-20 left-10 w-72 h-72 bg-primary/20 rounded-full blur-3xl float" />
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-secondary/20 rounded-full blur-3xl float" style={{ animationDelay: '2s' }} />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-accent/10 rounded-full blur-3xl" />
      </div>

      <div className="container mx-auto relative z-10">
        <div className="max-w-4xl mx-auto text-center space-y-8">
          {/* Badge */}
          <div className="flex justify-center fade-in-up">
            <Badge className="shimmer text-foreground px-4 py-2 text-sm font-medium">
              Trusted by thousands • Pay after activation
            </Badge>
          </div>

          {/* Main Headline */}
          <h1 className="text-4xl sm:text-5xl lg:text-7xl font-bold leading-tight fade-in-up" style={{ animationDelay: '0.1s' }}>
            <span className="gradient-text">Premium Subscriptions,</span>
            <br />
            <span className="text-foreground">Smarter Pricing</span>
          </h1>

          {/* Subheadline */}
          <p className="text-lg sm:text-xl text-muted-foreground max-w-2xl mx-auto leading-relaxed fade-in-up" style={{ animationDelay: '0.2s' }}>
            Unlock premium streaming, music, and Apple services at unbeatable prices. 
            Pay only after we activate your subscription and confirm it works.
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center fade-in-up" style={{ animationDelay: '0.3s' }}>
            <Button
              size="lg"
              className="bg-primary hover:bg-primary-glow text-primary-foreground shadow-elegant text-base px-8 py-6 font-semibold hover-glow"
              onClick={scrollToOffers}
            >
              Browse Offers
            </Button>
            <Button
              size="lg"
              variant="outline"
              className="border-primary/50 hover:bg-primary/10 text-foreground text-base px-8 py-6 font-semibold"
              onClick={() => window.open('https://www.instagram.com/metalearners.shop', '_blank')}
            >
              <Instagram className="w-5 h-5 mr-2" />
              Contact on Instagram
            </Button>
          </div>

          {/* Trust Chips */}
          <div className="flex flex-wrap gap-4 justify-center items-center pt-8 fade-in-up" style={{ animationDelay: '0.4s' }}>
            <div className="flex items-center gap-2 glass-card px-4 py-3 rounded-full">
              <Shield className="w-5 h-5 text-primary" />
              <span className="text-sm font-medium text-foreground">Pay after activation</span>
            </div>
            <div className="flex items-center gap-2 glass-card px-4 py-3 rounded-full">
              <HeadphonesIcon className="w-5 h-5 text-accent" />
              <span className="text-sm font-medium text-foreground">Full support</span>
            </div>
            <div className="flex items-center gap-2 glass-card px-4 py-3 rounded-full">
              <Zap className="w-5 h-5 text-success" />
              <span className="text-sm font-medium text-foreground">Fast delivery</span>
            </div>
          </div>

          {/* Scroll Indicator */}
          <div className="pt-12 fade-in-up" style={{ animationDelay: '0.5s' }}>
            <div className="inline-flex flex-col items-center gap-2 opacity-60 hover:opacity-100 transition-opacity cursor-pointer" onClick={scrollToOffers}>
              <span className="text-xs text-muted-foreground uppercase tracking-wider">Scroll to explore</span>
              <div className="w-6 h-10 border-2 border-muted-foreground/30 rounded-full flex items-start justify-center p-2">
                <div className="w-1.5 h-3 bg-muted-foreground rounded-full animate-bounce" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
